module.exports = __webpack_public_path__ + "media/images/sports_coaching/card-mobile@2x-e2a0f195eef030fcc0f811ad86f6353b.jpg";